import React from "react";
import {
    Alert,
    Box,
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    LinearProgress,
    Paper,
    Stack,
    Typography,
} from "@mui/material";

const IncomeReceiptDialog = ({
    open,
    onClose,
    receiptIncome,
    receiptPreview,
    receiptLoading,
    receiptError,
    isReceiptPdf,
    isReceiptImage,
    formatBytes,
    resolveIncomeDisplayName,
}) => (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
        <DialogTitle>Belegvorschau</DialogTitle>
        <DialogContent dividers>
            <Stack spacing={2}>
                <Stack spacing={0.5}>
                    <Typography variant="subtitle1" sx={{ fontWeight: 700 }}>
                        {receiptIncome ? resolveIncomeDisplayName(receiptIncome) : "Beleg"}
                    </Typography>
                    {receiptIncome?.originalFilename && (
                        <Typography variant="body2" sx={{ opacity: 0.7 }}>
                            Datei: {receiptIncome.originalFilename}
                        </Typography>
                    )}
                    {receiptPreview?.size ? (
                        <Typography variant="body2" sx={{ opacity: 0.7 }}>
                            {formatBytes(receiptPreview.size)}
                        </Typography>
                    ) : null}
                </Stack>

                {receiptLoading && <LinearProgress />}
                {!receiptLoading && receiptError && (
                    <Alert severity="error" variant="outlined">
                        {receiptError}
                    </Alert>
                )}
                {!receiptLoading && !receiptError && receiptPreview?.url && (
                    <Paper variant="outlined" sx={{ p: 2, borderRadius: 2 }}>
                        <Stack spacing={1}>
                            <Typography variant="subtitle2" sx={{ fontWeight: 700 }}>
                                Belegvorschau
                            </Typography>
                            {isReceiptPdf && (
                                <Box sx={{ height: { xs: "50vh", md: "70vh" } }}>
                                    <iframe
                                        title="Belegvorschau"
                                        src={receiptPreview.url}
                                        style={{ width: "100%", height: "100%", border: "none" }}
                                    />
                                </Box>
                            )}
                            {isReceiptImage && (
                                <Box sx={{ display: "flex", justifyContent: "center" }}>
                                    <Box
                                        component="img"
                                        src={receiptPreview.url}
                                        alt="Belegvorschau"
                                        sx={{ maxWidth: "100%", maxHeight: "70vh", borderRadius: 2 }}
                                    />
                                </Box>
                            )}
                            {!isReceiptPdf && !isReceiptImage && (
                                <Alert severity="info" variant="outlined">
                                    Vorschau fuer diesen Dateityp ist nicht verfuegbar.
                                </Alert>
                            )}
                        </Stack>
                    </Paper>
                )}
                {!receiptLoading && !receiptError && !receiptPreview?.url && (
                    <Typography variant="body2" color="text.secondary">
                        Keine Vorschau verfuegbar.
                    </Typography>
                )}
            </Stack>
        </DialogContent>
        <DialogActions>
            <Button onClick={onClose}>Schliessen</Button>
        </DialogActions>
    </Dialog>
);

export default IncomeReceiptDialog;
